import { load, save } from '../../../../../helpers/local-storage-serializer';
export const INSURANCE_REFUND_PROCESS = 'INSURANCE_REFUND_PROCESS';
export const INSURANCE_REFUNDED = 'INSURANCE_REFUNDED';
const localStorageName = 'orderRefundingInsurances';
export const getIsInsuranceRefunding = orderId => {
  const orderIds = load(localStorageName) || [];
  return orderIds.includes(orderId);
};
export const addRefundingInsurance = orderId => {
  const orderIds = load(localStorageName) || [];
  if (getIsInsuranceRefunding(orderId)) {
    return;
  }
  orderIds.push(orderId);
  save(localStorageName, orderIds);
};